var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adviceBtn",on:{"click":function($event){return _vm.goAdvice()}}},[_c('span',{staticClass:"iconfont icon-draft-fill"}),_c('span',{staticClass:"txt_tip"},[_vm._v("意见反馈")])])
}
var staticRenderFns = []

export { render, staticRenderFns }